import { AppButton } from "components/form";
import { AppUseIcon } from "components/ui";

export const AppLinkButton = ({
  text,
  onClick,
  iconName
}: {
  text: string,
  onClick: () => void,
  iconName?: string
}) => {

  return (<AppButton
    variant='link'
    fontFamily='lato'
    fontWeight='700'
    fontSize='15'
    className='color-textElementGrey text-underline pr-4 pl-0'
    onClick={onClick}
    uppercase={false}
  >
    {text}
    {iconName && (<AppUseIcon name={iconName} height='16' width='16' className='ml-1' />)}
  </AppButton>);
}
